import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/Button';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOverwriteAndImport: () => void;
  onImportWithoutOverwrite: () => void;
}

export function PresetDiffDialog({
  open,
  onOpenChange,
  onOverwriteAndImport,
  onImportWithoutOverwrite,
}: Props) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[640px] max-w-screen-sm p-0">
        {/* ヘッダー */}
        <div className="flex items-center justify-between border-b border-solid border-border px-lg py-md">
          <AlertDialogTitle className="text-heading-xs">
            取り込みプリセットに未保存の変更差分があります
          </AlertDialogTitle>
        </div>

        {/* 本文 */}
        <div className="p-lg">
          <AlertDialogDescription className="text-foreground text-body-sm">
            取り込みプリセットに差分を上書きしますか？
          </AlertDialogDescription>
        </div>

        {/* フッター */}
        <div className="flex justify-end gap-md border-t border-solid border-border px-lg py-md">
          <Button color="secondary" size="md" type="button" onClick={onImportWithoutOverwrite}>
            上書きせずに取り込み
          </Button>
          <Button color="primary" size="md" type="button" onClick={onOverwriteAndImport}>
            上書きして取り込み
          </Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
